import { gql } from '@apollo/client';

export const QUERY_ADDRESS_METADATA = gql`
  mutation QueryAddressMetadata($addressId: Long!) {
    queryAddressMetadata(addressId: $addressId) {
      id
      addressId
      dpvMatchCode
      dpvVacant
      dpvCmra
      dpvFootnotes
      rdi
      zipType
      recordType
      countyName
      countyFips
      precision
      precisionScore
      addressTypePrimary
      classificationSource
      classificationReason
      sourceMetadataJson
      source
      verificationMethod
    }
  }
`;

export const UPDATE_ADDRESS_METADATA = gql`
  mutation UpdateAddressMetadata($input: AddressMetadataInput!) {
    updateAddressMetadata(addressMetadataInput: $input)
  }
`;

export interface AddressMetadata {
  id?: number | null;
  addressId: number;
  dpvMatchCode?: string | null;
  dpvVacant: boolean;
  dpvCmra: boolean;
  dpvFootnotes?: string | null;
  rdi?: string | null;
  zipType?: string | null;
  recordType?: string | null;
  countyName?: string | null;
  countyFips?: string | null;
  precision?: string | null;
  precisionScore?: number | null;
  addressTypePrimary?: string | null;
  classificationSource?: string | null;
  classificationReason?: string | null;
  sourceMetadataJson?: string | null;
  source?: string | null;
  verificationMethod?: string | null;
}

export interface QueryAddressMetadataResponse {
  queryAddressMetadata: AddressMetadata | null;
}

export interface QueryAddressMetadataVariables {
  addressId: number;
}

export interface UpdateAddressMetadataResponse {
  updateAddressMetadata: boolean;
}

export interface UpdateAddressMetadataVariables {
  input: AddressMetadata;
}

